import styled from 'styled-components';
import { graySphera, greenSp, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';
import { spaceFlowContainer } from 'src/utilities/UIStyles/variables/spacing';

export const PersonalInformationContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  background-color: rgb(245, 245, 245);

  .card-container {
    ${spaceFlowContainer()}
  }
`;

export const Banner = styled.div`
  background-color: ${whiteSphera};
  padding: 2.5% 0 2.5% 10%;
  ${spaceFlowContainer(true)}

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;
    width: 100%;
    > figure {
      width: 8%;
      height: 8%;
      margin-right: 2.5%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
    > h2 {
      color: ${graySphera};
      font-size: 2vw;
      width: 80%;
    }
    > p {
      width: 80%;
      color: ${greenSp};
      font-weight: bold;
    }
  }

  @media (max-width: 600px) {
    > div {
      justify-content: center;
      > figure {
        width: 65px;
        height: 65px;
        > img {
        }
      }
      > h2 {
        font-size: 4vw;
        width: 70%;
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 80%;
  margin: 2.5% 10%;
  padding: 2.5%;
  background-color: ${whiteSphera};
  border-radius: 5px;
  > p {
    font-size: 1.3vw;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > p {
      font-size: 1.8vw;
    }
  }

  @media (max-width: 600px) {
    width: 95%;
    margin: 5% auto;
    padding: 5%;
    > p {
      font-size: 3.5vw;
    }
  }
`;

export const CompanyInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  > h3 {
    width: 70%;
    text-align: center;
  }
  & > div {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    gap: 1rem;
    > h3 {
      width: 100%;
      text-align: center;
      color: ${greenSp};
      margin-top: 5%;
    }
    > select {
      width: 100%;
      border-radius: 5px;
      padding: 1% 0;
    }
  }

  .checkbox {
    input {
      margin-right: 0.5rem;
    }
  }
`;

export const FormDataBiometricsFiles = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  > h3 {
    width: 100%;
    font-weight: bold;
    text-align: center;
  }
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    margin: 5% 10%;
    justify-content: center;
    > p {
      margin-top: 5%;
      color: ${graySphera};
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > p {
      font-size: 1.5vw;
    }
  }

  @media (max-width: 600px) {
    > p {
      font-size: 2.5vw;
    }
  }
`;

export const Container = styled.div`
  ${spaceFlowContainer()}

  display: flex;
  justify-content: space-around;
  text-align: center;
`;
